import { useCallback, useRef } from 'react';

export function useDebouncedCallback<T extends (...args: any[]) => void>(
  callback: T,
  delay: number,
) {
  const callbackRef = useRef(callback);

  return useCallback(
    (...args: any[]) => {
      if (!delay) {
        callback(...args);
        return;
      }
      clearTimeout(callbackRef.current as any);
      callbackRef.current = setTimeout(() => {
        callback(...args);
      }, delay) as any;
    },
    [delay, callback],
  );
}
